import * as React from 'react';
import get from 'lodash/get';
import { ComplexValue } from 'ui';
import { OptionsPanel } from './options-panel/options-panel';
import { PanelsProps } from './types';
import { sfNames, sfParameters } from './sf-names';
import { manageOptionsUnit } from 'app/area/shared/manage-options';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';
import { groupSelectorFieldName } from 'app/components/access-panel/options-panel/options-panel.utils';
import { selectedGroupText } from 'app/components/access-panel/shared/selected-group-text';

export const ExtendedAccess = (props: PanelsProps) => {
  const { translation, readOnly, data, formComponent, formValues, endpoints, validation, clearValueInStore, clearValidation,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData, updateAccessData,
    options, loadOptions } = props;

  const groupSelectorName = groupSelectorFieldName(sfNames.extendedAccess, sfParameters.application);
  const selectedGroup = get(formValues, groupSelectorName) as ComplexValue<number>;

  return <AdminPaperTopPanel title={translation.extended_access}>
    <OptionsPanel
      readOnly={readOnly}
      translation={translation}
      initialValue={data && data.extendedAccess}
      roleSelected={roleSelected}
      roleValue={roleBasedData && roleBasedData.extendedAccess}
      accessData={accessData && accessData.extendedAccess}
      updateAccessData={updateAccessData}
      fetchingRoleValue={fetchingRoleBasedData}
      formComponent={formComponent}
      formValues={formValues}
      formName={sfNames.extendedAccess}
      groupingName={sfParameters.application}
      valueName={sfParameters.unit}
      validation={validation}
      groupingOptionsEndpoint={endpoints.extendedAccess.caseType}
      valuesOptionsEndpoint={endpoints.extendedAccess.unit}
      groupingLabel={translation.case_type}
      valueLabel={selectedGroupText({ selectedGroup, translation })}
      addButtonText={translation.add_case_type_button_text}
      addSubButtonText={translation.add_units_button_text}
      clearValueInStore={clearValueInStore}
      clearValidation={clearValidation}
      useLabelOption={true}
      singleStepAccess={false}
      options={options}
      loadOptions={loadOptions}
      displaySelectAll={true}
      selectedGroup={selectedGroup}
      extraFooterButton={manageOptionsUnit(translation.manage_options)}
    />
  </AdminPaperTopPanel>;
};
